import { css, cx } from "@emotion/css"
import { ReactComponent as IconGraph } from "assets/icon-graph.svg"
import { Loading } from "components/Loading"
import { compactSmall } from "../../helpers/formatters"

const styles = {
  widgetCard: css`
    height: 227px;
    width: 204px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 32px 4px 32px 4px;
    border-radius: 12px;
  `,
  iconGraph: css`
    width: 48px;
    height: 48px;
    flex-grow: 0;
    object-fit: contain;
    padding: 4px;
    border-radius: 12px;
  `,
  info: css`
    flex-grow: 0;
    text-align: center;
    color: var(--white);
  `,
  detailSub: css`
    margin: 7px 5.5px 0;
    opacity: 0.85;
  `,
}

type WidgetCardProps = {
  currency: string
  value?: number
  detail1: string
  detail2: string
  className: string
  iconClassName: string
  isLoading?: boolean
}
export const WidgetCard = (props: WidgetCardProps) => {
  return (
    <div className={cx(styles.widgetCard, props.className)}>
      <div>
        <IconGraph className={cx(styles.iconGraph, props.iconClassName)} />
      </div>
      {props.isLoading ? (
        <Loading />
      ) : (
        <>
          <span className={cx("HeadingH4Regular", styles.info)}>
            {props.value !== null
              ? `${props.currency}${compactSmall(props.value)}`
              : "N/A"}
          </span>
          <span className={cx("HeadingH5bBold", styles.info)}>
            {props.detail1}
          </span>
          <span
            className={cx("HeadingH6Regular", styles.info, styles.detailSub)}
          >
            {props.detail2 ? props.detail2 : "N/A"}
          </span>
        </>
      )}
    </div>
  )
}
